import type { NewsroomContentObj } from '../_components/NewsroomBodySection';

export const newsroomContent: NewsroomContentObj[] = [
  {
    date: 'press_expand_metabolic_date',
    headline: 'press_expand_metabolic_title',
    subcopy: 'press_expand_metabolic_copy',
    url: 'https://www.businesswire.com/news/home/20240911441298/en/%C5%8CURA-Expands-Metabolic-Health-Expertise-with-Acquisition-of-Veri',
  },
  {
    date: 'press_oura_helps_millions_date',
    headline: 'press_oura_helps_millions_heading',
    subcopy: 'press_oura_helps_millions_subcopy',
    url: 'https://www.businesswire.com/news/home/20240614157633/en/%C5%8CURA-Helping-Millions-of-People-Improve-Their-Health-Surpasses-2.5-Million-Rings-Sold',
  },
  {
    date: 'press_john_lewis_launch_date',
    headline: 'press_john_lewis_launch_heading',
    subcopy: 'press_john_lewis_launch_subcopy',
    url: 'https://www.businesswire.com/news/home/20240527182443/en/Finnish-Smart-Ring-Company-%C5%8CURA-Launches-in-Store-Exclusively-at-John-Lewis',
  },
  {
    date: 'press_heart_health_launch_date',
    headline: 'press_heart_health_launch_heading',
    subcopy: 'press_heart_health_launch_subcopy',
    url: 'https://www.businesswire.com/news/home/20240510769393/en/%C5%8CURA-Announces-Two-New-Heart-Health-Features-Moving-Deeper-into-Preventative-Health',
  },
  {
    date: 'press_body_literacy_date',
    headline: 'press_body_literacy_heading',
    subcopy: 'press_body_literacy_subcopy',
    url: 'https://www.businesswire.com/news/home/20240430591268/en/%C5%8CURA-Announces-Be-the-Expert-in-You-Campaign-to-Promote-Body-Literacy-for-Women',
  },
  {
    date: 'press_oura_lab_date',
    headline: 'press_oura_lab_heading',
    subcopy: 'press_oura_lab_subcopy',
    url: 'https://www.businesswire.com/news/home/20240403398484/en/%C5%8CURA-Introduces-Oura-Labs-A-New-In-App-Innovation-Hub-for-Members',
  },
  {
    date: 'press_600_partners_date',
    headline: 'press_600_partners_heading',
    subcopy: 'press_600_partners_subcopy',
    url: 'https://www.businesswire.com/news/home/20231130504304/en/%C5%8CURA-Reaches-Milestone-of-600-Partnerships-and-Integrations-as-It-Builds-a-Large-Scale-Ecosystem',
  },
  {
    date: 'press_best_buy_date',
    headline: 'press_best_buy_heading',
    subcopy: 'press_best_buy_subcopy',
    url: 'https://www.businesswire.com/news/home/20231023806778/en/%C5%8CURA-Expands-Retail-Footprint-into-Canada-with-Best-Buy-Partnership',
  },
  {
    date: 'press_stress_launch_date',
    headline: 'press_stress_launch_heading',
    subcopy: 'press_stress_launch_subcopy',
    url: 'https://www.businesswire.com/news/home/20231010693570/en/%C5%8CURA-Debuts-Stress-Management-Features-and-Brushed-Titanium-Finish',
  },
  {
    date: 'press_talkspace_partner_date',
    headline: 'press_talkspace_partner_heading',
    subcopy: 'press_talkspace_partner_subcopy',
    url: 'https://www.businesswire.com/news/home/20230830553000/en/%C5%8CURA-and-Talkspace-Launch-First-of-Its-Kind-Holistic-Sleep-Partnership',
  },
  {
    date: 'press_proxy_acquisition_date',
    headline: 'press_proxy_acquisition_heading',
    subcopy: 'press_proxy_acquisition_subcopy',
    url: 'https://www.businesswire.com/news/home/20230509005326/en/%C5%8CURA-Acquires-Proxy-in-All-Equity-Deal',
  },
  {
    date: 'press_mab_new_members_date',
    headline: 'press_mab_new_members_heading',
    subcopy: 'press_mab_new_members_subcopy',
    url: 'https://www.businesswire.com/news/home/20230502005455/en/%C5%8CURA-Welcomes-Four-Experts-to-Newly-Appointed-Medical-Advisory-Board',
  },
  {
    date: 'press_retail_best_buy_date',
    headline: 'press_retail_best_buy_heading',
    subcopy: 'press_retail_best_buy_subcopy',
    url: 'https://www.businesswire.com/news/home/20230424005193/en/%C5%8CURA-Announces-First-Nationwide-Retail-Expansion-at-Best-Buy',
  },
];
